import React from 'react';
import PropTypes from 'prop-types';
import { LogoWrapper } from './styles';

/**
 * Selects a proper dimension for the header image.
 *
 * Some teams images need to be rendered in vertical, others in horizontal format.
 *
 * @param  teamId        String or Integer that identifies the team.
 * @return {Object}      Object that contains the image dimensions both for desktop and mobile.
 */
const dimensionSelector = (teamId) => {
  let dimensionObj;
  switch (teamId) {
    case 4 || '4':
    case 2 || '2':
      return dimensionObj = {
        widthMobile: '50px',
        heightMobile: '100px',
        widthDesk: '60px',
        heightDesk: '120px',
      };
    case 3 || '3':
      return dimensionObj = {
        widthMobile: '80px',
        heightMobile: '40px',
        widthDesk: '160px',
        heightDesk: '80px',
      };
    default:
      return '';
  }
};

const TeamLogo = ({
  image, isMobile, teamId,
}) => {
  const dimensionObj = dimensionSelector(teamId);
  return (
    <LogoWrapper
      width={isMobile ? dimensionObj.widthMobile : dimensionObj.widthDesk}
      height={isMobile ? dimensionObj.heightMobile : dimensionObj.heightDesk}
      src={image}
      onError={(e) => {
        e.target.src = 'https://images2.gazzettaobjects.it/assets-mc/countries/med/noflag.svg';
      }}
    />
  );
};

TeamLogo.propTypes = {
  image: PropTypes.any,
  isMobile: PropTypes.bool,
  teamId: PropTypes.any,
};


export default TeamLogo;



// WEBPACK FOOTER //
// ./src/lib/components/shared/TeamLogo/index.js